module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.importantTasks.length) ? _c('div', {
    staticClass: "important-tasks"
  }, [_c('div', {
    staticStyle: {
      "font-size": "10px",
      "color": "#666"
    }
  }, [_vm._v("\n            Important Clients\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "clickable"
  }, _vm._l((_vm.importantTasks), function(importantTask) {
    return _c('v-chip', {
      key: importantTask.meta.key,
      staticClass: "mr-1",
      attrs: {
        "title": importantTask.title,
        "dark": "",
        "color": _vm.importantTaskColour(importantTask)
      },
      on: {
        "click": function($event) {
          return _vm.taskClicked(importantTask)
        }
      }
    }, [_vm._v("\n                " + _vm._s(importantTask.clients) + "\n        ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "-8px",
      "margin-left": "85px",
      "color": "#bbb"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.transactionCount + ' client' + (_vm.transactionCount != 1 ? 's' : '')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-list"
  }, _vm._l((_vm.lenderTasks), function(lender, index) {
    return _c('div', {
      key: index,
      staticClass: "picture-card"
    }, [_c('div', {
      staticClass: "round-picture subtle-shadow picture-card-picture",
      style: (("background-image:url(/static/images/lenders/" + (encodeURI(lender.name)) + ".jpg)")),
      attrs: {
        "title": lender.name
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "elevation-2",
      staticStyle: {
        "border-radius": "8px",
        "padding": "6px",
        "background-color": "white"
      }
    }, _vm._l((lender.transactions), function(transaction, transactionIndex) {
      return _c('div', {
        key: transactionIndex,
        staticClass: "transaction-card clickable",
        on: {
          "click": function($event) {
            return _vm.transactionClicked(transaction)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-10px",
          "margin-right": "-10px"
        }
      }, [_c('a', {
        staticClass: "transparent",
        attrs: {
          "target": "_blank",
          "href": _vm.transactionLink(transaction),
          "title": "Open in new Tab"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('v-btn', {
        staticClass: "open-in-new",
        attrs: {
          "text": "",
          "icon": "",
          "color": "grey"
        }
      }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)]), _vm._v(" "), _c('b', [_vm._v(_vm._s(transaction.clients || 'No Name'))]), _c('v-btn', {
        staticClass: "no-focus",
        attrs: {
          "small": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "grey lighten-2"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.loadTransactionDetails(transaction)
          }
        }
      }, [_vm._v("mdi-chevron-down-circle")])], 1), _vm._v(" "), _c('v-expand-transition', [(_vm.settings.condensed) ? _c('span', _vm._l((transaction.tasks), function(task) {
        return _c('span', {
          key: task._key,
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.taskClicked(task)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(task.title) + "\n                        ")])
      }), 0) : _vm._e(), _vm._v(" "), (transaction.description) ? _c('div', [_vm._v("\n                        " + _vm._s(transaction.description) + " \n                        "), (transaction.broker) ? _c('span', {
        staticClass: "light-text small-text"
      }, [_vm._v(" (Broker: " + _vm._s(transaction.broker) + ")")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.settings.condensed) ? _c('div', {
        staticClass: "pt-1"
      }, _vm._l((transaction.tasks), function(task) {
        return _c('div', {
          key: task.key,
          staticClass: "pa-1 task-row hover-container clickable",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.taskClicked(task)
            }
          }
        }, [_c('ul', [_c('li', [(_vm.daysTillDue(task) < 0) ? _c('div', {
          staticClass: "red darken-1",
          staticStyle: {
            "border-radius": "2px",
            "margin-bottom": "-1px",
            "margin-right": "2px",
            "width": "12px",
            "height": "12px",
            "background-color": "#ccc",
            "display": "inline-block"
          }
        }) : _vm._e(), _vm._v(" "), (task.sectionTitle) ? _c('span', [_vm._v(_vm._s(task.sectionTitle) + " >")]) : _vm._e(), _vm._v("\n                                " + _vm._s(task.title || task.text) + "\n                                "), (_vm.settings.showInitials) ? _c('b', [_vm._v(_vm._s(_vm.initials(task.assigned)))]) : _vm._e(), _vm._v(" "), (task.important) ? _c('Flag', {
          attrs: {
            "primary": ""
          }
        }, [_vm._v("Important")]) : _vm._e(), _vm._v(" "), _c('flag', [_vm._v(_vm._s(task.status))]), _vm._v(" "), (_vm.daysTillDue(task) != 0) ? _c('span', {
          staticClass: "grey--text text--lighten-1"
        }, [_vm._v(" (" + _vm._s(_vm._f("dueString")(task.due)) + ")")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "task-edit show-on-hover",
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openTask(task)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "grey"
          }
        }, [_vm._v("edit")])], 1)], 1)])])
      }), 0) : _vm._e()], 1)
    }), 0)])])
  }), 0), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee7f3b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TasksByLender.vue
// module id = 2450
// module chunks = 1